import styled from 'styled-components';

export const Sidebar = styled.div`
  display: block;
  background-color: #f5f4f5;
  border-right: 1px solid #dbd9d9;
  border-bottom-left-radius: 5px;
  padding: 10px 0;
  width: 180px;
  min-width: 180px;
  height: 100%;
  /* min-width: 180px; */
  cursor: grab;
  transition: all ease 300ms;
  /* @media only screen and (max-width: 500px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 60px;
    min-width: 60px;
    /* width: 1015px; */
  /* } */
  ${(props) =>
    props.expand &&
    `
    @media only screen and (max-width: 500px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 60px;
      min-width: 60px;
    }
  `}
`;

export const SidebarLabel = styled.span`
  font-size: 11px;
  color: #5d646b;
  font-weight: 700;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  padding: 5px 10px;
`;

export const SidebarLink = styled.div`
  display: flex;
  width: 100%;
  height: 26px;
  padding: 5px 20px;
  &:hover {
    cursor: pointer;
    background: #dfdedf;
    background: linear-gradient(to right, #dfdedf 50%, #d9d4d4 100%);
  }

  ${(props) =>
    props.active &&
    `
    background: #dfdedf;
    background: linear-gradient(to right, #dfdedf 50%, #d9d4d4 100%);
  `}

  svg {
    width: 1em;
    height: 1em;
  }

  @media only screen and (max-width: 500px) {
    justify-content: center;
  }
`;

export const SidebarLinkText = styled.div`
  font-size: 14px;
  padding-left: 7px;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  /* @media only screen and (max-width: 500px) {
    display: none;
    /* width: 1015px; */
  /* } */
  ${(props) =>
    props.expand &&
    `
    @media only screen and (max-width: 500px) {
      display: none;
    }
  `}
`;
